import Api from '@/services/Api'
const path = 'salesman'

export default {
    login(login, password) {
        return Api().get(path + `/login`, {
            params: {
                login,
                password
            }
        })
    },
    changePassword(newPassword) {
        return Api().post(path + `/changePassword`, {
            newPassword,
            hasChangedPassword: true
        })
    },
    list(name, login, active, page) {
        return Api().get(path + `/list`, {
            params: {
                name,
                login,
                active,
                page
            }
        })
    },
    createUpdate(item) {
        return Api().post(path + `/createUpdate`, {
            id: item.id,
            password: item.password,
            isActive: item.isActive,
            login: item.login,
            name: item.name
        })
    },
}